import { createContext } from "react";
import type { Atom } from "jotai";
import type { ComponentName, ComponentState } from "app/componentOptions";

export const MobileComponentStateContext = createContext<Atom<
  ComponentState<ComponentName>
> | null>(null);
